import script from "./query.vue?vue&type=script&setup=true&lang=js"
export * from "./query.vue?vue&type=script&setup=true&lang=js"

import "./query.vue?vue&type=style&index=0&id=2acb55c4&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2acb55c4"]])

export default __exports__